import { render, staticRenderFns } from "./main.vue?vue&type=template&id=61d2efaf"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d2efaf')) {
      api.createRecord('61d2efaf', component.options)
    } else {
      api.reload('61d2efaf', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=61d2efaf", function () {
      api.rerender('61d2efaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/masters/manual/main.vue"
export default component.exports